// Monta elementos sem innerHTML (texto do usuário nunca vira HTML).
//   h('button', { class: 'botao', onClick: salvar }, 'Salvar')
const PROPRIEDADES = new Set(['value', 'checked', 'disabled', 'selected', 'hidden', 'required', 'readOnly', 'multiple', 'indeterminate']);

export function h(tag, props = null, ...filhos) {
  const el = document.createElement(tag);
  if (props) {
    for (const [chave, valor] of Object.entries(props)) {
      if (valor === null || valor === undefined || valor === false) continue;
      if (chave === 'class') el.className = valor;
      else if (chave === 'dataset') Object.assign(el.dataset, valor);
      else if (chave === 'style' && typeof valor === 'object') Object.assign(el.style, valor);
      else if (chave.startsWith('on') && typeof valor === 'function') el.addEventListener(chave.slice(2).toLowerCase(), valor);
      else if (PROPRIEDADES.has(chave)) el[chave] = valor;
      else el.setAttribute(chave, valor === true ? '' : String(valor));
    }
  }
  anexar(el, filhos);
  return el;
}

export function anexar(el, filhos) {
  for (const filho of filhos.flat(Infinity)) {
    if (filho === null || filho === undefined || filho === false || filho === true) continue;
    el.append(filho instanceof Node ? filho : document.createTextNode(String(filho)));
  }
  return el;
}

export function trocar(el, ...filhos) {
  el.replaceChildren();
  return anexar(el, filhos);
}

// Ícones próprios, desenhados em SVG simples (traço, 24×24).
const DESENHOS = {
  inicio: '<path d="M3 11.5 12 4l9 7.5"/><path d="M5.5 10v10h13V10"/><path d="M10 20v-5h4v5"/>',
  caminhao: '<path d="M2 6h11v10H2z"/><path d="M13 9h4.5l3.5 4v3h-8z"/><circle cx="6" cy="17.5" r="2"/><circle cx="17" cy="17.5" r="2"/>',
  pessoas: '<circle cx="9" cy="8" r="3.2"/><path d="M3 20c.6-3.6 3-5.5 6-5.5s5.4 1.9 6 5.5"/><circle cx="17" cy="9" r="2.5"/><path d="M16.5 14.2c2.5.2 4 1.9 4.5 4.8"/>',
  clientes: '<path d="M4 20V5h10v15"/><path d="M14 10h6v10"/><path d="M7 8h2M7 11h2M7 14h2M10.5 8h.5M10.5 11h.5M10.5 14h.5M17 13h.5M17 16h.5"/><path d="M2 20h20"/>',
  conta: '<circle cx="12" cy="8.5" r="3.8"/><path d="M4.5 20c1-4 3.9-6 7.5-6s6.5 2 7.5 6"/>',
  mais: '<path d="M12 5v14M5 12h14"/>',
  voltar: '<path d="M15 5l-7 7 7 7"/>',
  seta: '<path d="M9 5l7 7-7 7"/>',
  sair: '<path d="M14 4h5v16h-5"/><path d="M10 8l-4 4 4 4"/><path d="M6 12h10"/>',
  check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>',
  ajuda: '<circle cx="12" cy="12" r="9"/><path d="M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.7.3-1 .8-1 1.5v.7"/><path d="M12 17v.5"/>',
  alerta: '<path d="M12 3 2 20h20z"/><path d="M12 10v4.5M12 17.5v.5"/>',
  placa: '<rect x="3" y="7" width="18" height="10" rx="2"/><path d="M7 12h10"/>',
  carreta: '<path d="M2 6h15v9H2z"/><path d="M17 12h5"/><circle cx="7" cy="17.5" r="2"/><circle cx="12" cy="17.5" r="2"/>',
  rota: '<circle cx="6" cy="18" r="2.3"/><circle cx="18" cy="6" r="2.3"/><path d="M8.3 18H15a3 3 0 0 0 0-6H9a3 3 0 0 1 0-6h6.7"/>',
  menu: '<path d="M4 7h16M4 12h16M4 17h16"/>',
  dinheiro: '<rect x="3" y="6" width="18" height="12" rx="2"/><circle cx="12" cy="12" r="2.6"/><path d="M6.5 9.5v5M17.5 9.5v5"/>',
  camera: '<path d="M3.5 8.5h3.2l1.8-2.5h7l1.8 2.5h3.2V19h-17z"/><circle cx="12" cy="13.2" r="3.4"/>',
  bomba: '<path d="M5 20V5.5A1.5 1.5 0 0 1 6.5 4h6A1.5 1.5 0 0 1 14 5.5V20"/><path d="M3.5 20h12"/><path d="M7.5 8h4"/><path d="M14 9h2.2a1.8 1.8 0 0 1 1.8 1.8v5.4a1.3 1.3 0 0 0 2.6 0V9.5l-2.6-3"/>',
  recibo: '<path d="M6 3.5h12V21l-2.5-1.5L13 21l-2.5-1.5L8 21l-2-1.5z"/><path d="M9 8h6M9 11.5h6M9 15h3.5"/>',
  calendario: '<rect x="3.5" y="5" width="17" height="15.5" rx="2"/><path d="M3.5 10h17M8 3v4M16 3v4"/>',
  grafico: '<path d="M4 4v16h16"/><path d="M8 16v-4M12 16V8M16 16v-6"/>',
  telefone: '<path d="M5 4h3.5l1.8 4.6-2.2 1.4a11.5 11.5 0 0 0 5.9 5.9l1.4-2.2L20 15.5V19a1.8 1.8 0 0 1-1.9 1.8A16.5 16.5 0 0 1 3.2 5.9 1.8 1.8 0 0 1 5 4z"/>',
  local: '<path d="M12 21s-6.5-5.8-6.5-11a6.5 6.5 0 0 1 13 0c0 5.2-6.5 11-6.5 11z"/><circle cx="12" cy="10" r="2.4"/>',
  chave: '<path d="M14.5 5.5a4.5 4.5 0 0 0 5 5.6l-8.6 8.6a2.3 2.3 0 0 1-3.3-3.3l8.6-8.6a4.5 4.5 0 0 0-1.7-2.3z"/><path d="M14.5 5.5l2.2 2.2 2.8-2.8"/>',
};

export function icone(nome, { tamanho = 24, classe = 'icone' } = {}) {
  const span = document.createElement('span');
  span.className = classe;
  span.setAttribute('aria-hidden', 'true');
  span.innerHTML = `<svg viewBox="0 0 24 24" width="${tamanho}" height="${tamanho}" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">${DESENHOS[nome] ?? ''}</svg>`;
  return span;
}
